const KEY_PREFIX = "jeux_cb:";

export function getBestScore(gameId: string): number {
  const raw = localStorage.getItem(KEY_PREFIX + "best:" + gameId);
  const n = raw ? Number(raw) : 0;
  return Number.isFinite(n) ? n : 0;
}

export function setBestScore(gameId: string, score: number): number {
  const best = Math.max(getBestScore(gameId), score);
  localStorage.setItem(KEY_PREFIX + "best:" + gameId, String(best));
  return best;
}
